import { supabase } from '../lib/supabase';

export const appLogService = {
  async log(level, context, message, payload = null) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      let companyId = null;
      if (user?.id) {
        const { data: profile } = await supabase
          ?.from('user_profiles')
          ?.select('company_id')
          ?.eq('id', user?.id)
          ?.maybeSingle();
        companyId = profile?.company_id || null;
      }
      await supabase?.from('app_logs')?.insert({
        company_id: companyId,
        level,
        context,
        message,
        payload_json: payload ? JSON.parse(JSON.stringify(payload)) : null
      });
    } catch (err) {
      console.error('[appLogService] Failed to write log:', err);
    }
  },
  async info(context, message, payload = null) { return this.log('info', context, message, payload); },
  async warn(context, message, payload = null) { return this.log('warn', context, message, payload); },
  async error(context, message, payload = null) { return this.log('error', context, message, payload); }
};
